// extracted by mini-css-extract-plugin
export var inlineLink = "_4j-0";
export var inlineLinkButton = "_4j-1";